export class UwmRequestTimeoutError extends Error {
    constructor(requestType: string) {
        super(`UWM request "${requestType}" timed out waiting for a host response.`);
        this.name = 'UwmRequestTimeoutError';
    }
}

export class UwmResponseError extends Error {
    readonly code: string;

    constructor(code: string) {
        super(`UWM host responded with error: ${code}`);
        this.name = 'UwmResponseError';
        this.code = code;
    }
}
